import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import { IconButton, Tooltip } from '@mui/material';
import { GridPreferencePanelsValue } from '@mui/x-data-grid-pro';
import { useDataGridApi } from 'components/common/withDataGridApi';
import { formatTranslation } from 'intl';
import { CommonTranslationKeys } from 'intl/keys';
import { MouseEvent, ReactElement, useId, useRef } from 'react';
import { useIntl } from 'react-intl';
import { useDataGridPreferencePanelToggle } from './hooks/useDataGridPreferencePanelToggle';
import { columnSettingsButtonSx } from './toolbarStyles';

interface DataGridColumnSettingsButtonProps {
  dataQa?: string;
}

export function DataGridColumnSettingsButton({
  dataQa = 'table-view-column-settings-button',
}: DataGridColumnSettingsButtonProps): ReactElement {
  const intl = useIntl();
  const apiRef = useDataGridApi();
  const columnPanelId = useId();
  const columnButtonId = useId();
  const wasOpenAtInteractionRef = useRef<boolean | undefined>(undefined);
  const { isPanelOpen, onToggle } = useDataGridPreferencePanelToggle(
    apiRef,
    GridPreferencePanelsValue.columns,
    { panelId: columnPanelId, buttonId: columnButtonId }
  );

  const label = formatTranslation(intl, CommonTranslationKeys.dataGridManageColumns);

  const handleMouseDownCapture = (event: MouseEvent): void => {
    event.stopPropagation();
    wasOpenAtInteractionRef.current = isPanelOpen();
  };

  const handleClick = (event: MouseEvent): void => {
    event.stopPropagation();
    onToggle(wasOpenAtInteractionRef.current);
    wasOpenAtInteractionRef.current = undefined;
  };

  return (
    <Tooltip title={label}>
      <IconButton
        id={columnButtonId}
        size='large'
        aria-label={label}
        onMouseDownCapture={handleMouseDownCapture}
        onClick={handleClick}
        data-qa={dataQa}
        sx={columnSettingsButtonSx}
      >
        <ViewColumnIcon />
      </IconButton>
    </Tooltip>
  );
}
